<div class="wrapper-modal near-you">
    <div class="wrapper-modal-content">
        <span class="title-modal-near-you">
            {{'NEAR_YOU_PAGE.what_are_near_you_pins?' | translate}}
        </span>
        <div class="content-near-you-modal">
          <div class="near-you-modal-item">
            <img src="../../../assets/icons/pin-blue.svg" alt="">
            <img class="icon-arrow" src="../../../assets/icons/icon-arrow-right.svg" alt="">
            <span>
                    {{'NEAR_YOU_PAGE.your_item_on_the_map' | translate}}
                </span>
          </div>
            <div class="near-you-modal-item">
                <img src="../../../assets/icons/pin-purple.svg" alt="">
                <img class="icon-arrow" src="../../../assets/icons/icon-arrow-right.svg" alt="">
                <span>
                    {{'NEAR_YOU_PAGE.an_item_from_somebodys_list' | translate}}
                </span>
            </div>
            <div class="near-you-modal-item">
                <img src="../../../assets/icons/pin-yellow.svg" alt="">
                <img class="icon-arrow" src="../../../assets/icons/icon-arrow-right.svg" alt="">
                <span>
                    {{'NEAR_YOU_PAGE.multiple_items_from_lists_on_this_area' | translate}}
                </span>
            </div>
        </div>
        <div (click)="saveMapLegend()" class="modal-buttons">
            <button class="custom-btn custom-btn--primary" (click)="saveMapLegend()"><span>
                {{'NEAR_YOU_PAGE.i_understand' | translate}}
            </span></button>
        </div>
    </div>
</div>
